import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { fetchHighRiskPatientsInfoSixMonth } from "../../services/patients";
import { LoaderCircle } from 'lucide-react';

export default function HighRiskChart(props) {
  const {account_id,location_id,last_n_months} = props;

  const currentDate = new Date(); 
  const currentYear = currentDate.getFullYear();
  const [isLoading, setIsLoading] = useState(false);
  const [prevCurrentPer, setPrevCurrentPer] = useState(0);
  const [getMonthName, setGetMonthName] = useState([]);
  const [patientVisited, setPatientVisited] = useState([]);
  const [loss, setLoss] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    loadHRPatientsInfo(account_id,location_id,last_n_months);
  },[account_id, location_id]);

  const loadHRPatientsInfo = async(account_id,location_id,month=4,year=currentYear,last_n_months=6) => {
    try {
      const response = await fetchHighRiskPatientsInfoSixMonth(account_id,location_id,month,year,last_n_months);

      if(response){
        if(response?.detail) {
          setPrevCurrentPer(0);
          setGetMonthName([]);
          setPatientVisited([]);
          console.log("🚀 ~ loadHRPatientsInfo ~ error:", response);
        } else {
          const originalData = response?.data;
          const responseData = originalData.reverse();

          // const currentHRPatient = responseData[0]?.high_risk_patients_visited || 0;
          // const prevHRPatient = responseData[1]?.high_risk_patients_visited || 0;
          // const percentage = prevHRPatient ? ((currentHRPatient - prevHRPatient) / prevHRPatient) * 100 : 0;
          // setPrevCurrentPer(percentage);
          const currentHRPatient = parseFloat(responseData[5]?.high_risk_patients_visited) || 0;
          const prevHRPatient = parseFloat(responseData[4]?.high_risk_patients_visited) || 0;
          
          if(prevHRPatient > currentHRPatient || prevHRPatient === currentHRPatient) {
            setLoss(false);
          } else {
            setLoss(true);
          }
          
          const percentLoss = ((prevHRPatient - currentHRPatient) / prevHRPatient) * 100;
          setPrevCurrentPer(isNaN(percentLoss) ? "0.00" : percentLoss.toFixed(2));

          const months = responseData.map((item) => item.month);
          const visits = responseData.map((item) => item.high_risk_patients_visited);

          setGetMonthName(months);
          setPatientVisited(visits);
        }
      }
    } catch (error) {
      setPrevCurrentPer(0);
      setGetMonthName([]);
      setPatientVisited([]);
      // console.log("🚀 ~ loadHRPatientsInfo ~ error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const options = {
    chart: {
      height: 120,
      type: 'bar',
      toolbar: {
        show: false,
      },
    },
    colors: ['#5EB0EF'],
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '35%',
        distributed: false,
        borderRadius: 1,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '11px',
        colors: ['#fff'],
      },
      formatter: function (val) {
        return val;
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: getMonthName?.map((month) => month?.substring(0, 3)),
      labels: {
        show: true,
        style: {
          colors: '#817F8B',
          fontSize: '12px',
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (value) {
          return `${value}`;
        },
      },
      x: {
        formatter: function (value, { dataPointIndex }) {
          return getMonthName[dataPointIndex];
        },
      },
    },
  };

  const series = [
    { name: 'Patient', data: patientVisited },
  ];

  return (
    <div className="highrisk_chart">
      { isLoading ? 
        <div className="flex items-center loading" style={{ width: '100%', height: '100%', minHeight: '216px', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px' }}>
          <span className="docpro_loading" style={{ position: 'inherit' }}>
            <LoaderCircle width={50} height={50} style={{color:"#369eff"}} />
          </span>
        </div>
      :
        <>
          <h2 className="docpro_fs_18 docpro_mb_0">High-risk patient visits by per month</h2>
          <div className='docpro_chart'>
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={180}
            />
          </div>
          <p className='docpro_mb_0'>
            {loss ?
              <>
                <span className='docpro_green_color'>{Math.abs(prevCurrentPer)}%</span> patient <span className='docpro_green_color'>rise</span>
              </>
            :
              <>
                <span className='docpro_red_color'>{Math.abs(prevCurrentPer)}%</span> patient <span className='docpro_red_color'>drop</span>
              </>
            }
            &nbsp;in this month, compared to last month
          </p>
        </>
      }
    </div>
  );
}